import React, { useState, useEffect } from 'react'
import { Row, Table, Tag } from "antd";
import { getOutgoingShippingWithPage } from '../../../services/serviceWarehouseOutgoing';
import userDateFormatter from "../../../services/formatters/userDateFormatter";
import ConfirmDispatch from "./ConfirmDispath";
import { SearchOutlined } from "@ant-design/icons";
import Filter from "../../filterWrapper/Filter";
import DispatchFilter from "./DispatchFilter";
import { useLocation, navigate } from "@reach/router";


const OutgoingDispatch = () => {
    const location = useLocation();
    const [tableData, setTableData] = useState([])
    const [reloadTable, setReloadTable] = useState(false)
    const [openFilter, setOpenFilter] = useState(false)
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });
    const [filters, setFilters] = useState({
        customerName: '',
        dispatchNo: '',
        shipmentStatus: null
    });
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const page = parseInt(queryParams.get('pn')) || 1;
        const pageSize = parseInt(queryParams.get('ps')) || 10;

        getShippingOrders(page, pageSize);
    }, [location.search]);

    const getShippingOrders = (page, pageSize, requestObj = filters) => {
        const mockFilters = { ...requestObj };
        mockFilters.pageSize = pageSize;
        mockFilters.pageNo = Number(page) - 1;

        getOutgoingShippingWithPage(mockFilters)
            .then(({ data }) => {
                reduceData(data.content);
                setPagination({
                    ...pagination,
                    current: page,
                    total: data.totalElements,
                    pageSize: pageSize
                })
                setExpandedRowKeys([]);
            })
    };

    const handlePaginationChange = (pageNumber, pageSize) => {
        navigate(`?ps=${pageSize}&pn=${pageNumber}`);
    };

    const isToday = (date) => {
        const dateItems = date.split('/');
        const today = new Date();
        const month = today.getMonth() + 1;
        const dateNumber = today.getDate();

        return Number(dateItems[1]) === month && Number(dateItems[0]) === dateNumber;
    };

    const columns = [
        {
            title: 'İrsaliye No',
            dataIndex: 'dispatchNo',
            key: 'dispatchNo'
        },
        {
            title: 'Müşteri',
            dataIndex: 'customer',
            key: 'customer'
        },
        {
            title: 'Sevk Tarihi',
            dataIndex: 'shipmentDate',
            key: 'shipmentDate',
            render: (t, r) => isToday(r.shipmentDate) ? <Tag color={'purple'} >{t}</Tag> : <Tag color={'cyan'}>{t}</Tag>
        },
        {
            title: 'İşlemler',
            render: (t, r) => <ConfirmDispatch record={r} reloader={reloadData} />
        }
    ]
    const reloadData = () => setReloadTable(!reloadTable)
    const reduceData = (data) => {
        const tableSource = data.map((item, index) => {
            return {
                key: index,
                shipmentStatus: item.ss,
                id: item.id,
                shipmentDate: userDateFormatter(item.sd),
                dispatchNo: item.dn,
                customer: item.cn,
                shippingOrderContentList: JSON.parse(item.soc) || []
            }
        })
        setTableData(tableSource)
    }
    const expandedRowRender = (record) => {
        const localData = record.shippingOrderContentList.map((item, index) => {
            return {
                key: index,
                stock: item.snc,
                warehouse: item.w,
                quantity: item.q,
                unit: item.u
            }
        })
        const localColumn = [
            {
                title: 'Stok Adı', dataIndex: 'stock', key: 'stock'
            },
            {
                title: 'Depo', dataIndex: 'warehouse', key: 'warehouse'
            },
            {
                title: 'Miktar', dataIndex: 'quantity', key: 'quantity'
            },
            {
                title: 'Birim', dataIndex: 'unit', key: 'unit'
            }
        ]
        return (
            <React.Fragment>
                <Table className={'expanded-table'} scroll={{ x: 'max-content' }} dataSource={localData} columns={localColumn} pagination={false} />
            </React.Fragment>
        )
    }
    const toggleFilterDisplay = () => setOpenFilter(!openFilter)
    function handleFilter({ customerName, dispatchNo, shipmentStatus }) {
        const requestObj = {}
        Object.keys(arguments[0]).map(key => {
            requestObj[key] = arguments[0][key]
        })
        setFilters(requestObj);
        navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);
        return new Promise((resolve) => resolve(200))
    };

    const resetFilters = () => {
        const baseObj = {
            customerName: '',
            dispatchNo: '',
            shipmentStatus: null
        };
        setFilters(baseObj);
        navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);
    };

    const handleRowExpand = ({key}) => {
        const keyIndex = expandedRowKeys.indexOf(key);
        if (keyIndex !== -1) {
            const keys = expandedRowKeys.toSpliced(keyIndex, 1);
            setExpandedRowKeys(keys);
            return;
        }
        const wholeExpanded = [...expandedRowKeys, key];
        setExpandedRowKeys(wholeExpanded);
    } 

    return (
        <React.Fragment>
            <Row justify={"start"}>
                <div className={'filter-row-container'} onClick={toggleFilterDisplay}><SearchOutlined /></div>
            </Row>
            <Table
                scroll={{ x: 'max-content' }}
                dataSource={tableData}
                columns={columns}
                expandable={{ expandedRowRender, onExpand: (ex, r) => handleRowExpand(r), expandedRowKeys: expandedRowKeys }}            
                pagination={{
                    ...pagination,
                    showSizeChanger: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    onChange: handlePaginationChange,
                }}
            />
            {
                <Filter
                    showDrawer={openFilter}
                    closer={toggleFilterDisplay}
                    relatedComponent={'İrsaliye Çıkış'}
                    handler={handleFilter}
                    resetHandler={resetFilters}
                >
                    <DispatchFilter />
                </Filter>
            }
        </React.Fragment>
    )
}
export default OutgoingDispatch